import {ref} from 'vue';
import type {
  TSelectOption,
  SelectProps,
} from '~/interfaces/ui/select';

export function useSelect(props: SelectProps, emit: any) {
  const current = ref<TSelectOption | null>(null);
  const open = ref(false);
  const opts = ref<Array<TSelectOption>>([]);

  function toggleOpen() {
    open.value = !open.value;
    if (open.value) {
      emit('focus');
    }
  }

  function chooseOption(option: TSelectOption) {
    if (option.selected && current.value?.selected) {
      current.value.selected = false;
      current.value = null;
      emit('update:modelValue', null);
    } else {
      if (current.value) {
        current.value.selected = false;
      }
      current.value = option;
      current.value.selected = true;
      emit(
        'update:modelValue',
        props.returnObject ? option : option.id,
      );
      emit('change', props.returnObject ? option : option.id);
    }
    closeSelect();
  }

  function closeSelect() {
    open.value = false;
  }

  function setOptions() {
    opts.value =
      props.options?.map((option: TSelectOption) => ({
        ...option,
        text: option.value,
        value: option.id,
        selected: String(option.id) === String(props.modelValue),
      })) || [];
    current.value = opts.value.find((item) => item.selected) || null;
  }

  return {
    closeSelect,
    chooseOption,
    toggleOpen,
    opts,
    open,
    current,
    setOptions,
  };
}
